import React from 'react';
import s from './styles.module.css'
import Wrapper from '../../components/wrapper';
import HeaderTitle from '../../components/header_title';

const CookiePolicy = () => {
  return (
    <div className={s.main}>
      <Wrapper>
        <HeaderTitle/>
        <h1>Política de Cookies</h1>

        <h2>1. ¿Qué son las cookies?</h2>

        <p>
          Las cookies son pequeños archivos de texto que se almacenan en el dispositivo del usuario cuando visita un sitio web.
        </p>

        <p>
          Estas tecnologías permiten que los sitios web recuerden información sobre la visita del usuario y mejoren su experiencia de navegación.
        </p>

        <h2>2. Uso de cookies en himyloan.com</h2>

        <p>
          El sitio utiliza cookies y tecnologías similares para garantizar el correcto funcionamiento del Sitio Web, analizar el tráfico y mejorar la experiencia de los usuarios.
        </p>

        <p>
          Las cookies pueden ser propias o de terceros.
        </p>

        <h2>3. Tipos de cookies que utilizamos</h2>

        <h3>Cookies necesarias</h3>

        <p>
          Estas cookies son esenciales para el funcionamiento básico del Sitio Web y permiten utilizar determinadas funciones.
        </p>

        <p>
          Sin estas cookies, algunas partes del sitio podrían no funcionar correctamente.
        </p>

        <h3>Cookies de análisis</h3>

        <p>
          Utilizamos cookies analíticas para comprender cómo los usuarios utilizan nuestro Sitio Web y mejorar nuestro contenido.
        </p>

        <p>
          Estas cookies pueden recopilar información como:
        </p>

        <ul>
          <li>Número de visitantes;</li>
          <li>Páginas visitadas;</li>
          <li>Tiempo de permanencia en el sitio;</li>
          <li>Tipo de dispositivo utilizado;</li>
          <li>Navegador utilizado.</li>
        </ul>

        <h3>Cookies de afiliación</h3>

        <p>
          Algunos enlaces de nuestro Sitio Web pueden pertenecer a programas de afiliación.
        </p>

        <p>
          Estas cookies permiten a nuestros socios identificar referencias y atribuir correctamente las comisiones correspondientes.
        </p>

        <p>
          Estas cookies no aumentan el precio de ningún producto o servicio para el usuario.
        </p>

        <h2>4. Google Analytics</h2>

        <p>
          Utilizamos Google Analytics para recopilar información estadística sobre el uso del Sitio Web.
        </p>

        <p>
          Google Analytics puede utilizar cookies para analizar:
        </p>

        <ul>
          <li>Cómo llegan los usuarios al sitio;</li>
          <li>Qué páginas visitan;</li>
          <li>Cuánto tiempo permanecen en el sitio;</li>
          <li>Cómo interactúan con el contenido.</li>
        </ul>

        <p>
          La información recopilada por Google Analytics se procesa de acuerdo con las políticas de privacidad de Google.
        </p>

        <h2>5. Gestión y eliminación de cookies</h2>

        <p>
          El usuario puede aceptar, bloquear o eliminar las cookies mediante la configuración de su navegador.
        </p>

        <p>
          La mayoría de navegadores permiten:
        </p>

        <ul>
          <li>Eliminar cookies existentes;</li>
          <li>Bloquear todas las cookies;</li>
          <li>Configurar avisos antes de almacenar cookies.</li>
        </ul>

        <p>
          La desactivación de cookies puede afectar al funcionamiento de algunas partes del Sitio Web.
        </p>

        <h2>6. Cookies de terceros</h2>

        <p>
          Algunos servicios utilizados en nuestro Sitio Web pueden establecer cookies propias, de acuerdo con sus propias políticas de privacidad.
        </p>

        <p>
          Recomendamos consultar las políticas de cookies de dichos proveedores externos.
        </p>

        <h2>7. Cambios en esta Política de Cookies</h2>

        <p>
          Podemos actualizar esta Política de Cookies cuando sea necesario debido a cambios legales, técnicos o relacionados con nuestros servicios.
        </p>
      </Wrapper>
    </div>
  );
};

export default CookiePolicy;
